import { render, staticRenderFns } from "./EditEditorPackage.vue?vue&type=template&id=4b97b5a7&scoped=true&"
import script from "./EditEditorPackage.vue?vue&type=script&lang=js&"
export * from "./EditEditorPackage.vue?vue&type=script&lang=js&"
import style0 from "./EditEditorPackage.vue?vue&type=style&index=0&id=4b97b5a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97b5a7",
  null
  
)

export default component.exports